require('./overrides.sass')

const preset = {
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: '#136F4D',
        secondary: '#045D56',
        tertiary: '#FF6859',
        quaternary: '#FFCF44',
        quinary: '#B15DFF',
        senary: '#72DEFF',
        anchor: '#28ab78'
      },
    },
  },
}

module.exports = { preset }
